import { isChordNotes } from './chord-types.js'
import type { Chord } from './chord-types.js'
import { getNotes } from './get-notes.js'

/**
 * Determines whether two chords are equal by comparing their notes.
 *
 * This function checks if both chords contain the same notes, regardless of order.
 * If either chord is undefined, the function returns `undefined`.
 *
 * @param a - The first chord to compare.
 * @param b - The second chord to compare.
 * @returns `true` if both chords have the same notes, `false` if not, or `undefined` if either chord is missing.
 */
export const chordEquals = (a?: Chord, b?: Chord) => {
  if (!a || !b) {
    return
  }
  const notesA = isChordNotes(a) ? a.notes : getNotes(a)
  const notesB = isChordNotes(b) ? b.notes : getNotes(b)

  return Boolean(a && b && notesA.every(n => notesB.includes(n)) && notesB.every(n => notesA.includes(n)))
}
